import { PlanSibling } from '@anm/api/modules/pricing';
import PlanButton from '@anm/components/pricing/PlanButton';
import PlanTitleBlock, { PlanTitleBlockProps } from '@anm/components/pricing/PlanTitleBlock';
import Price, { PriceProps } from '@anm/components/pricing/Price';
import { FC } from 'react';
import styled from 'styled-components';

import PlanSiblingDropdown, { PlanSiblingDropdownProps } from '../PlanSiblingDropdown';

export type PlanPeriodButtonBlockProps = Pick<PriceProps, 'discount'> & {
  price: number;
  variant: PlanTitleBlockProps['variant'];
  planName: string;
  isAnnual: boolean;
  periodName: string;
  isSamePlan: boolean;
  description: string;
  isSamePeriod: boolean;
  showPlanButton: boolean;
  siblingDropdownOptions?: PlanSiblingDropdownProps['options'];
  sibling?: PlanSibling;
  disabled?: boolean;
  onGetPlanClick?: () => void;
  onSiblingChange?: (sibling: PlanSibling) => void;
};

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
const PlanPeriodButtonBlock: FC<PlanPeriodButtonBlockProps> = ({
  price,
  sibling,
  variant,
  discount,
  planName,
  isAnnual,
  isSamePlan,
  periodName,
  isSamePeriod,
  siblingDropdownOptions,
  showPlanButton,
  disabled = false,
  onGetPlanClick,
  onSiblingChange
}) => (
  <>
    <TitleContainer>
      <PlanTitleBlock {...{ variant }} title={planName} />
      {sibling && siblingDropdownOptions && onSiblingChange && (
        <PlanSiblingDropdown value={sibling} options={siblingDropdownOptions} onChange={onSiblingChange} />
      )}
    </TitleContainer>
    <Price {...{ price, variant, isAnnual, discount }} />
    {showPlanButton && (
      <div>
        <PlanButton
          {...{ planName, isSamePlan, periodName, isSamePeriod }}
          disabled={disabled}
          siblingName={sibling?.name}
          onClick={onGetPlanClick}
        />
      </div>
    )}
  </>
);

export default PlanPeriodButtonBlock;
